import { CredentialsSignin } from 'next-auth';

export const ERROR_CODES = {
  // AUTH ERROR CODES
  MISSING_CREDENTIALS: 'MISSING_CREDENTIALS',
  INVALID_CREDENTIALS: 'INVALID_CREDENTIALS',
  EMAIL_NOT_VERIFIED: 'EMAIL_NOT_VERIFIED',
  ACCOUNT_SUSPENDED: 'ACCOUNT_SUSPENDED',
  AN_UNEXPECTED_ERROR_OCCURRED: 'AN_UNEXPECTED_ERROR_OCCURRED',
};

export class InvalidCredentialsError extends CredentialsSignin {
  code = ERROR_CODES.INVALID_CREDENTIALS;
}

export class MissingCredentialsError extends CredentialsSignin {
  code = ERROR_CODES.MISSING_CREDENTIALS;
}

export class EmailNotVerifiedError extends CredentialsSignin {
  code = ERROR_CODES.EMAIL_NOT_VERIFIED;
}

export class AccountSuspendedError extends CredentialsSignin {
  code = ERROR_CODES.ACCOUNT_SUSPENDED;
}

export class AnUnexpectedErrorOccurredError extends CredentialsSignin {
  code = ERROR_CODES.AN_UNEXPECTED_ERROR_OCCURRED;
}
